/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    a: "a",
    div: "div",
    p: "p",
    code: "code",
    pre: "pre"
  }, _provideComponents(), props.components), {MakeCodeExtensionFooter} = _components;
  if (!MakeCodeExtensionFooter) _missingMdxReference("MakeCodeExtensionFooter", true);
  return React.createElement(React.Fragment, null, React.createElement(_components.h1, {
    id: "flex",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#flex",
    "aria-label": "flex permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "Flex"), "\n", React.createElement(_components.p, null, "The flex extension (for a flexible/bending sensor) reports the sensor\nvalue as a floating point value between 0.0 and 100.\nThe ", React.createElement(_components.code, null, "bending"), " method returns the current value of the sensor."), "\n", React.createElement(_components.p, null, "The following program outputs the sensor value whenever it changes by\n5:"), "\n", React.createElement(_components.pre, null, React.createElement(_components.code, {
    className: "language-blocks"
  }, "modules.flex1.onBendingChangedBy(5, function() {\n    led.plotBarGraph(modules.flex1.bending(), 100)\n})\n")), "\n", React.createElement(_components.h1, {
    id: "jm-flex-v10",
    style: {
      position: "relative"
    }
  }, React.createElement(_components.a, {
    href: "#jm-flex-v10",
    "aria-label": "jm flex v10 permalink",
    className: "anchor before"
  }, React.createElement(_components.div, {
    dangerouslySetInnerHTML: {
      __html: "<svg aria-hidden=\"true\" focusable=\"false\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg>"
    }
  })), "JM Flex v1.0"), "\n", React.createElement(_components.p, null, "The ", React.createElement(_components.a, {
    href: "/jacdac-docs/devices/microsoft-research/jmflexv10"
  }, "JM Flex v1.0"), " module has a flexible\nsensor that changes in value when bent away from the top of the board (which contains\nthe blue pre-set resistor - square box)."), "\n", React.createElement(MakeCodeExtensionFooter, {
    serviceName: "flex"
  }));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
